import Option from "@p-ban/common/src/components/form/SelectBox/Option"
import Select from "@p-ban/common/src/components/form/SelectBox/Select"
import { range } from "@p-ban/common/src/utils/NumberUtils"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import { resolveRouletteKindName } from "../../../../../service/impositionNameResolver/impositionNameResolver"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidRoulette from "../../../../service/visibleValidator/isValidRoulette"

import img from "./roulette.png"

const ミシン目面付け = ({ values, handlers, errors }: OneClickFieldProps) => {
  const condition = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)
  const shouldShow = condition.roulette || condition.rouletteKind

  return (
    <OneClickField isShow={shouldShow} legend="ミシン目面付け" helpURL={HELP_LINKS.ミシン目面付け} src={img}>
      <OneClickFieldStack>
        <Select
          name={FIELD_NAMES["ミシン目面付け 面付け数"]}
          value={values.roulette}
          onChange={handlers.select}
          shouldRender={(value) => isValidRoulette(values, value)}
          aria-label="面付け数"
        >
          {Object.values(ESTIMATE_CONSTANT["ミシン目面付け 面付け数"]).map(({ name, value }) => (
            <Option key={value} value={value}>
              {name}
            </Option>
          ))}
        </Select>
        {condition.rouletteKind && (
          <Select
            name={FIELD_NAMES["ミシン目面付け 種類"]}
            value={values.rouletteKind ?? ""}
            onChange={handlers.selectAsNumber}
            disabled={disabled.rouletteKind}
            aria-label="種類"
          >
            <Option value="">選択してください</Option>
            {[...range(1, 31)].map((value) => (
              <Option key={value} value={value}>
                {resolveRouletteKindName(value)}
              </Option>
            ))}
          </Select>
        )}
      </OneClickFieldStack>
      <OneClickFieldMessages error={errors?.roulette} />
      <OneClickFieldMessages error={errors?.rouletteKind} />
    </OneClickField>
  )
}

export default ミシン目面付け
